import {RefreshCw} from 'lucide-react';
import {Button} from './ui/button';

export const PublicDataError = ({id, label, error, onRetry}) => (
  <div className="public-data-error" role="alert" data-testid={`${id}-load-error`}>
    <div>
      <strong data-testid={`${id}-load-error-title`}>{label} could not be loaded.</strong>
      <p data-testid={`${id}-load-error-message`}>{error}</p>
    </div>
    <Button variant="outline" type="button" data-testid={`${id}-retry`} onClick={onRetry}>
      <RefreshCw size={15}/> Try again
    </Button>
  </div>
);